export default __webpack_public_path__ + "static/media/sbo-icon-active.42c06ce9.svg";